import React, { useEffect, useState } from "react";
import {
  notificationStrings,
  openNotificationWithIcon,
} from "../../../../common/notification-message/notification";

import CreateNewCodeheader from "./createNewCodeHeader";
import Createuserheader from "../../createnewuser/createuserheader";
import { getCreateReferrerCode } from "../../manageuserVerification/utils";
import { useHistory } from "react-router-dom";

const CreateNewCode = ({ searchByValuePlaceholder }) => {
  const history = useHistory();
  const [code, setCode] = useState("");
  const [username, setUsername] = useState("");
  const [loader, setLoader] = useState(false);
  const [codeId, setCodeID] = useState("");

  const handleCode = (e) => {
    setCode(e.target.value);
  };
  const handleUsername = (e) => {
    setUsername(e.target.value);
  };

  useEffect(() => {
    const { uuid } = require("uuidv4");
    setCodeID(uuid());
  }, []);
  const handleSubmit = (e) => {
    e.preventDefault();

    createNewUser();
  };
  const createNewUser = () => {
    // request.size = sizeShow || 10;
    const requestObj = {
      id: codeId,
      code: code,
      name: username,
    };
    setLoader(true);
    getCreateReferrerCode(requestObj)
      .then((res) => {
        setLoader(false);
        console.log("new user response", res.data);

        history.push("/admin/ReferrerCode");

        openNotificationWithIcon(
          notificationStrings.success,
          "Refferer Code Created Successfully."
        );
      })
      .catch((err) => {
        setLoader(false);
        history.push("/admin/ReferrerCode");
      });
  };

  return (
    <CreateNewCodeheader
      code={code}
      setCode={setCode}
      loader={loader}
      username={username}
      setUsername={setUsername}
      handleCode={handleCode}
      handleUsername={handleUsername}
      handleSubmit={handleSubmit}
      searchByValuePlaceholder={searchByValuePlaceholder}
    />
  );
};

export default CreateNewCode;
